<template>
  <div class="step step-two rvr-standconfigurator">
    <StandConfigurator />
  </div>
</template>

<script>

import useStepNavigation from "@/composables/useStepNavigation";
import StandConfigurator from "@/components/public/forms/StandConfigurator.vue";
import {watch} from "vue";
import useTexts from "@/composables/useTexts";

export default {
  name: 'PublicStepTwo',
  components: {
    StandConfigurator
  },
  setup() {
    const { curStep, nextButtonEnabled, nextButtonText, previousButtonPressed, goToPreviousStep } = useStepNavigation();
    const { getTextsForComponent } = useTexts();
    const t = getTextsForComponent('PublicStepTwo');

    curStep.value = 2;

    nextButtonEnabled.value = false;
    nextButtonText.value = t.value.next_step;

    watch(previousButtonPressed, (isPressed) => {
      if (isPressed) {
        previousButtonPressed.value = false;
        goToPreviousStep();
      }
    });

    return {
      curStep,
    };
  },
};
</script>

<style scoped>
.step {background: #e9e9e9; padding: 20px; border-radius: 4px;}
</style>
